export default __webpack_public_path__ + "static/media/117_xhypno_kawai_0001.1753bddd.png";